import React, { ComponentType } from 'react';

import { Props, TabType, FaqGroupProps } from './props';
import { tabs, KnowledgeList } from './setting';
import s from './styles/FaqInquiry.module.css';

const FAQ = 'faq';
const KNOWLEDGE = 'knowledge';

// index.tsx（CSR、lazy()+Suspense）とindex.ssr.tsx（SSR専用、eager import）の両方が
// このBodyを共有する。lazy()の戻り値もeager importの戻り値もReact.ComponentTypeとして
// 同じ形でJSXに渡せるため、「どちらの読み込み方をしたか」だけが差分になり、
// 実際の画面構造（switch分岐・JSXツリー）は1箇所にしか存在しない。
export type AboutSiteComponents = {
    PagePC: ComponentType<any>;
    PageSP: ComponentType<any>;
    Tab: ComponentType<any>;
    Breadcrumb: ComponentType<any>;
    FooterInquiryPC: ComponentType<any>;
    FooterInquirySP: ComponentType<any>;
    Faq: ComponentType<any>;
    Knowledge: ComponentType<any>;
};

// currentPathはRailsのProps（業務データ）に含めず、packs/application.js・server-bundle.jsの
// register関数がrailsContext.pathnameから渡すpropとして別枠で受け取る（PR #2082 Point2対応）
type AboutSiteProps = Props & { currentPath?: string; components: AboutSiteComponents };

export const AboutSiteBody = (props: AboutSiteProps) => {
    const { components } = props;
    const breadcrumbName = props.tab === KNOWLEDGE ? 'ゴルフ会員権の基礎知識' : 'よくあるご質問';
    const breadcrumbs = [
        {
            name: 'トップ',
            url: '/',
        },
        {
            name: breadcrumbName,
            url: '',
        },
    ];
    const Page = props.isSp ? components.PageSP : components.PagePC;
    const FooterInquiry = props.isSp ? components.FooterInquirySP : components.FooterInquiryPC;
    const pageProps = mapServerPropsToProps({
        ...props,
        knowledgePage: { ...props.knowledgePage, cards: KnowledgeList },
    });
    const tabWidth = props.isSp ? '164px' : '250px';
    const justifyContent = props.isSp ? 'center' : 'left';
    return (
        <Page
            contentHead={
                <>
                    <components.Breadcrumb breadcrumbList={breadcrumbs} />
                    <components.Tab
                        tabs={tabs}
                        current={props.tab}
                        width={tabWidth}
                        outerClass={s.tab_outer}
                        innerClass={s.tab_inner}
                        justifyContent={justifyContent}
                    />
                </>
            }
            contentFooter={
                <div className={props.tab === FAQ && props.isSp ? s.gray_bg : ''}>
                    <FooterInquiry />
                </div>
            }
            currentPath={props.currentPath}
        >
            <TabContent tab={props.tab} props={pageProps} faqs={props.faqs} components={components} />
        </Page>
    );
};

const mapServerPropsToProps = (props: Props): Props => {
    return {
        ...props,
        knowledgePage: {
            ...props.knowledgePage,
            cards: props.knowledgePage.cards,
        },
    };
};

type TabContentProps = {
    tab: TabType;
    props: Props;
    faqs?: FaqGroupProps;
    components: AboutSiteComponents;
};

const TabContent = (props: TabContentProps) => {
    switch (props.tab) {
        case KNOWLEDGE:
            return <props.components.Knowledge {...props.props.knowledgePage} />;
        case FAQ:
            return <props.components.Faq faqs={props.faqs} />;
        default:
            return null;
    }
};
